import { Roles, RolesEnv } from '@/app/enums';
import {
  rolelist,
  type UserValidation,
} from '@/features/session/types/session.types';
import appLocalStorage from '@/features/session/store/appLocalStorage';

// Utility function to get the user's role based on environment and access profile
// If a user object is provided, uses that; otherwise, fetches from local storage
// Returns the highest priority role for the current environment, or UNKNOWN if not found
const getRole = (user: UserValidation): Roles => {
  let userAccess;

  // Use provided user or get from local storage
  if (user) {
    userAccess = user;
  } else {
    userAccess = appLocalStorage.getUserAccessProfile() as UserValidation;
  }

  if (userAccess) {
    // Destructure access roles from user profile
    const {
      roles: { access },
    } = userAccess;

    // Determine current environment (PROD or TEST)
      const currentRoleEnv: RolesEnv =
        import.meta.env.VITE_APP_ENV === RolesEnv.PROD
          ? RolesEnv.PROD
          : RolesEnv.TEST;

    // Find access roles for the current environment
    const currentAccessRoles = access.find(
      accessRoles => accessRoles.env === currentRoleEnv
    )?.roles;

    // If only one role, return it; otherwise, return the highest priority role
    const role =
      currentAccessRoles?.length === 1
        ? currentAccessRoles[0].role
        : currentAccessRoles?.sort(
            (a, b) =>
              (rolelist.find(e => e.role === a.role)?.priority || 0) -
              (rolelist.find(e => e.role === b.role)?.priority || 1)
          )[0]?.role;

    return (role as Roles) || Roles.UNKNOWN;
  }

  // Return UNKNOWN if no user or access found
  return Roles.UNKNOWN;
};

export default getRole;
